@use "../../../styles/accessibility.scss";

.switchInput {
  --ixf-switch-track-border-radius: 12px;
  --ixf-switch-border-width: 1px;
  --ixf-switch-border-width-focused: 2px;
  --ixf-switch-knob-height: 18px;
  --ixf-switch-knob-width: 18px;
  --ixf-switch-track-width: 32px;
  --ixf-switch-track-height: 20px;
  --ixf-switch-padding: var(--ixf-space-2) 0;
  --ixf-switch-knob-icon-size: 16px;
  --ixf-switch-border-color: var(--ixf-color-separator);

  padding: var(--ixf-switch-padding);
  overflow: visible;

  &:not(.isDisabled) {
    cursor: pointer;
  }

  .label {
    &.isHidden {
      @include accessibility.visually-hidden;
    }
  }

  .track {
    height: calc(
      var(--ixf-switch-track-height) + (var(--ixf-switch-border-width) * 2)
    );
    width: calc(
      var(--ixf-switch-track-width) + (var(--ixf-switch-border-width) * 2)
    );
    border-radius: var(--ixf-switch-track-border-radius);
    background: var(--ixf-color-neutral-md);
    position: relative;
    display: inline-flex;

    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      border-radius: var(--ixf-switch-track-border-radius);
      border: var(--ixf-switch-border-width) solid transparent;
      background: var(--ixf-color-background);
      mask:
        linear-gradient(#fff 0 0) padding-box,
        linear-gradient(#fff 0 0);
      mask-composite: exclude;
    }

    &::after {
      background: var(--ixf-switch-border-color);
    }

    &:focus,
    &:focus-visible {
      outline: none;
    }

    &:focus-visible {
      &::after {
        top: calc(var(--ixf-switch-border-width) * -1);
        left: calc(var(--ixf-switch-border-width) * -1);
        height: calc(100% + var(--ixf-switch-border-width-focused));
        width: calc(100% + var(--ixf-switch-border-width-focused));
        border: var(--ixf-switch-border-width-focused) solid transparent;
        border-radius: var(--ixf-switch-track-border-radius);
        background: var(--ixf-color-rainbow-gradient) border-box;
      }
    }

    &.isOn {
      --ixf-switch-border-color: var(--ixf-text-tone-md);

      background: var(--ixf-text-tone-md);

      .knob {
        transform: translateX(
          calc(var(--ixf-switch-track-width) - var(--ixf-switch-knob-width))
        );
      }
    }

    .knob {
      height: var(--ixf-switch-knob-height);
      width: var(--ixf-switch-knob-width);
      border-radius: 50%;
      background: var(--ixf-color-background);
      box-shadow: var(--ixf-box-shadow-toggle-knob);
      position: absolute;
      left: 0;
      top: calc(var(--ixf-switch-border-width) * 2);
      transform: translateX(calc(var(--ixf-switch-border-width) * 2));
      transition: transform 0.2s ease-in-out;

      svg {
        left: var(--ixf-switch-border-width);
        position: relative;
        top: var(--ixf-switch-border-width);
        width: var(--ixf-switch-knob-icon-size);
      }
    }
  }

  &.isDisabled {
    .knob,
    .track {
      cursor: default;
    }
  }
}
